import { useGetTaskResultQuery } from '@/modules/common/queries/tasks.ts';
import TaskResultInfoModal, {
  TaskResultInfo,
} from '@/modules/admin-dashboard/components/modals/TaskResultInfoModal.tsx';
import { BaseModalProps } from 'ui';
import { User } from 'compliance-api';

interface TaskResultInfoModalWithLoadingProps extends BaseModalProps {
  task: TaskResultInfo['task'];
  user: User;
  resultId: number;
}

const TaskResultInfoModalWithLoading = ({
  open,
  task,
  user,
  resultId,
  onClose,
}: TaskResultInfoModalWithLoadingProps) => {
  const { data, isLoading } = useGetTaskResultQuery(resultId);
  const result = data?.task_result;

  return (
    <TaskResultInfoModal
      key={resultId}
      open={open}
      onClose={onClose}
      taskResultInfo={{ task, result, user }}
      isLoading={isLoading}
      errorMessage={isLoading || result ? null : 'Something went wrong, task result not found'}
    />
  );
};

export default TaskResultInfoModalWithLoading;
